// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WF8f","col":"styles_col__2rBD1"};